import React from 'react'

interface DisplayLevelComponentProps {
    level?: number | null
    className?: string
    label?: string
}

const DisplayLevelComponent = ({ level, className = '', label }: DisplayLevelComponentProps) => {
    return level !== null ?
          <div className="gw-competency-view-level">
            <span className="gw-competency-view-level-label">{label}:</span>
            <span className={`gw-competency-view-level-value ${className}`}>Level {level}</span>
          </div> : null
      }
      
export default DisplayLevelComponent
